import { useEffect } from 'react'
import useIsOtcOnlyUser from 'hooks/useIsOtcOnlyUser'
import { usePlusClient } from 'providers/VisionRouter'

// OTC-only users are pinned to their assigned location. If they clear or change the
// locationId/locationIds URL params, reapply their token location automatically.
const useEnforceOtcLocation = (): void => {
  const isOtcOnlyUser = useIsOtcOnlyUser()
  const {
    tokenContext,
    currentLocation: { queryMap },
    routeToMergedQuery,
  } = usePlusClient()

  const assignedLocationId: string | undefined = tokenContext?.locationId
  const currentLocationId: string | undefined = queryMap?.locationId
  const rawLocationIds = queryMap?.locationIds
  const currentLocationIds: string[] = Array.isArray(rawLocationIds)
    ? rawLocationIds
    : rawLocationIds
    ? [rawLocationIds]
    : []

  useEffect(() => {
    if (!isOtcOnlyUser || !assignedLocationId) return

    const locationIdMatches = currentLocationId === assignedLocationId
    const locationIdsMatches = currentLocationIds.length === 1 && currentLocationIds[0] === assignedLocationId

    if (!locationIdMatches || !locationIdsMatches) {
      routeToMergedQuery({ locationId: assignedLocationId, locationIds: [assignedLocationId] })
    }
    // Re-check on any query change (not just the location fields) so the guard self-heals
    // if another effect on the page overwrites the query and drops the location.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOtcOnlyUser, assignedLocationId, JSON.stringify(queryMap)])
}

export default useEnforceOtcLocation
